import React , { useState ,useEffect  , useRef }  from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import {
useCompanyBalanceSheet
} from 'data/company';

import {number_format,APP_URL,formatINR , capitalizeWords} from 'components/config/Common';

export default function BalancesheetSection({companyinfo,type}) {
      const [openSections, setOpenSections] = useState({});
      const [viewType, setViewType] = useState('Consolidated');
      const containerRef = useRef(null);
      const [scrolled, setScrolled] = useState(false);
    // Map to store background color of each parent section
    const parentBgMap = {};

    const toggleSection = (sectionno) => {
      setOpenSections((prev) => ({
        ...prev,
        [sectionno]: !prev[sectionno],
      }));
    };

  /* useEffect(() => {
    console.log('Type changed:', type);

    const apiType = type ? 'Standalone' : 'Consolidated';

    refetchPF({
      id: companyinfo?.id,
      type: apiType,
      company_type: companyinfo?.company_type
    });

  }, [type]);
  */
   useEffect(() => {
         // code runs whenever `type` changes
      console.log('Type changed:', type);
            if(type){
              setViewType(capitalizeWords(type));
            }else{
              setViewType('Consolidated');
            }
    /* refetchCF({id:companyinfo?.id,type:(type?'Consolidated':'Standalone'),
        company_type:companyinfo?.company_type
      });
      */
    }, [type]);

  
    const {
      balancesheet,
      years_list,
      lable_array:labelArray,
      isLoading: loading,
      error,
      refetch:refetchPF,
    } = useCompanyBalanceSheet({id:companyinfo?.id,type:(type?'Standalone':'Consolidated'),
      company_type:companyinfo?.company_type
    });

    console.log("balancesheet",balancesheet);

 


   /* const isEmptyBalanceSheet =
  !balancesheet || Object.keys(balancesheet).length === 0;

     useEffect(() => {
  // If user is on Consolidated page but no data → fallback to Standalone
  if (!type && isEmptyBalanceSheet) {
    refetchPF({
      id: companyinfo?.id,
      type: 'Standalone',
      company_type: companyinfo?.company_type
    });
  }
}, [balancesheet]);
*/

    const getTypeByName = (periodName) => {
    if (!labelArray) return null;

    const found = Object.values(labelArray).find(
      (item) => item.name.trim() === periodName.trim()
    );

  return found ? found.type : null;
};

 const getSecByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.section : null;
};


const getPostfixByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.postfix : null;
};

const getTextcssByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.textbold : null;
};



/** code for scrolling */
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setScrolled(container.scrollLeft > 0);
    };

    container.addEventListener("scroll", handleScroll);

    return () => container.removeEventListener("scroll", handleScroll);
  }, []);


const hasConsolidatedData =
  balancesheet?.["Consolidated"] &&
  Object.keys(balancesheet["Consolidated"]).length > 0;

const hasStandaloneData =
  balancesheet?.["Standalone"] &&
  Object.keys(balancesheet["Standalone"]).length > 0;

// Decide final view type
let finalViewType = viewType;

if (viewType === "Consolidated" && !hasConsolidatedData && hasStandaloneData) {
  finalViewType = "Standalone";
}

// Use finalViewType everywhere
const selectedData = balancesheet?.[finalViewType] ?? {};
const selectedYearlist = years_list?.[finalViewType] ?? {};

 // const selectedData = balancesheet?.[viewType] ?? {};
  //const selectedYearlist = years_list?.[viewType] ?? {};

  console.log("selectedData",selectedData);
  console.log("ratio data",balancesheet);

  const hasConsolidated =
  balancesheet?.["Standalone"] &&
  Object.keys(balancesheet["Standalone"]).length > 0;


  return (
      <section className="bg-white shadow-md z-50 rounded-xl py-5">
      	
        <h2 className="text-2xl font-semibold px-5">Balance Sheet</h2>
       {/* <div> Standalone Figures in Rs. Crores / {type? 
             <Link to={`${APP_URL}/company/${companyinfo?.symbol}`} className="text-accent underline ml-1">
            View Consolidated
          </Link>
          : 
           <Link to={`${APP_URL}/company/${companyinfo?.symbol}/standalone`} className="text-accent underline ml-1">
                View Standalone
              </Link>
          } </div>
         </div>
         {!type && isEmptyBalanceSheet && (
          <div className="px-5 text-sm text-yellow-600">
            Consolidated data not available. Showing Standalone instead.
          </div>
        )}
        <div className="py-4"></div>*/}

        <div className="text-heading px-5">
                                 Standalone Figures in Rs. Crores
                                  {!type && hasConsolidated && (
                                    <>
                                      {" / "}
                                      <Link
                                        to={`${APP_URL}/company/${companyinfo?.symbol}/standalone`}
                                        className="text-accent underline ml-1"
                                      >
                                        View Standalone
                                      </Link>
                                    </>
                                  )}
                        
                                  {type && (
                                    <>
                                      {" / "}
                                      <Link
                                        to={`${APP_URL}/company/${companyinfo?.symbol}`}
                                        className="text-accent underline ml-1"
                                      >
                                         View Consolidated
                                      </Link>
                                    </>
                                  )}
                                </div>
                                {viewType === "Consolidated" && finalViewType === "Standalone" && (
                                <div className="px-5 text-sm text-yellow-600">
                                  Consolidated data not available. Showing Standalone results instead.
                                </div>
                              )}
                <div className="py-4"></div>
        {loading?
        null
        :
        <div ref={containerRef} class="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base ">
            <table 
              
             class="w-full text-sm text-left border-0 rtl:text-right text-body">
                <thead class="bg-neutral-secondary-soft border-b border-default">
                    <tr >
                        <th scope="col" class="px-6 py-2">
                           
                        </th>
                         {Object.entries(selectedYearlist).map(([keyyear, valyear]) => (
                            <th scope="col" className="text-right px-6 py-2 ">{valyear}</th>
                          ))}
                    </tr>
                </thead>
                <tbody>
                 {Object.keys(selectedData || {}).length === 0 ? (
                                  <div className="p-5 text-heading"> data is not ready yet , please check again
                                </div>
                                    ) : (<>
                {Object.entries(selectedData).map(([period, qresults],index) => {
                    const type = getTypeByName(period); // or value.name
                  const sectionno = getSecByName(period);

                    const postfix = getPostfixByName(period);
                  const textbold = getTextcssByName(period);


                  // If this is a parent row → compute & store bg
                    if (type === "parent") {
                      parentBgMap[sectionno] =
                        index % 2 === 0
                          ? "bg-gray-50"
                          :  "bg-white";
                    }

                    // Now rowBg ALWAYS exists (because child uses parent's stored bg)
                    const rowBg = parentBgMap[sectionno] || "bg-white";

                  // Find all children belonging to this section
                  const children = Object.entries(balancesheet).filter(
                    ([p, data]) => getSecByName(p) === sectionno && getTypeByName(p) === "child"
                  );
                   console.log("childrenlist",rowBg);
                  const hasChild = children.length > 0;
                  
                  return(<React.Fragment key={sectionno}>  
                   {type === "parent" &&
                   <tr 
                   className={`${rowBg} ${textbold} cursor-pointer ${openSections[sectionno] ? "border-t-2 " : ""}  `}
                  onClick={() => type === "parent" && toggleSection(sectionno)}                      >
                    
                      <td className={`px-2 md:px-6 py-2 sticky left-0 z-20 ${rowBg} w-10 md:w-fit `} >
                        <div className={`flex gap-1 whitespace-nowrap items-center ${openSections[sectionno] ? "text-accent " : "text-heading"} `}>{period}
                            {hasChild && (
                        <> {openSections[sectionno] ? (
                              <MinusIcon className="w-3 h-3 text-accent" />
                            ) : (
                              <PlusIcon className="w-3 h-3 text-accent" />
                            )}</>
                          )}
                          </div>
                        </td>


                      {Object.entries(qresults).map(([key, qresultsval]) => (
                         
                          <td className={`text-right px-6 py-3 text-heading  text-wrap `} >{qresultsval ? <>{formatINR(qresultsval,2)}{postfix}</> : null} </td>
                      ))}
                      </tr>
                    }
                      {openSections[sectionno] && type === 'child' &&
                       <tr 
                         className={`${rowBg}  cursor-pointer`}
>                    
                      <td className={`px-6 py-2 text-black sticky left-0 z-30  gap-1 whitespace-nowrap items-center ${rowBg}`} >
                        {period}
                        </td>
                      {Object.entries(qresults).map(([key, qresultsval]) => (
                         
                          <td className={`text-right px-6 py-3 text-heading whitespace-nowrap`} >{qresultsval} {postfix}</td>
                      ))}
                      </tr>}
                    
                   </React.Fragment>)
                })}
                 </>
                                    )}  
                </tbody>
            </table>
        </div>
        }
       
      </section> 
  );
}
